import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const CreateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: ${pxToRem('20px')};
`;

export const InputContainer = styled.input`
  width: 100%;
  height: ${pxToRem('56px')};
  padding: ${pxToRem('12px')} ${pxToRem('29px')} ${pxToRem('12px')}
    ${pxToRem('20px')};
  border-radius: ${pxToRem('8px')};
  border: ${props =>
    props.error
      ? `solid ${pxToRem('1px')} ${props.theme.colors.statusRed}`
      : `solid ${pxToRem('1px')} rgba(70, 122, 251, 0.56)`};
  background-color: #fff;
  margin: ${pxToRem('20px')} 0;
  outline: none;
  font-family: ${({ theme }) => theme.fontset.opensans};
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: ${pxToRem('10px')} ${pxToRem('0px')};
`;

export const ItemContainer = styled.div`
  padding-top: ${pxToRem('10px')};
`;

export const TitleContainer = styled.div`
  text-align: center;
  padding-top: ${pxToRem('10px')};
`;

export const AcceptButtonContainer = styled.div`
  margin: ${pxToRem('40px')} auto ${pxToRem('20px')} auto;
  display: flex;
  justify-content: center;
`;

export const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.statusRed};
`;

export const RoleIcon = styled.div`
  background: url(${props => props.icon});
  background-repeat: no-repeat;
  width: ${pxToRem('20px')};
  height: ${pxToRem('20px')};
  background-size: contain;
`;

export const SitesDropDown = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${pxToRem('24px')};
  height: ${pxToRem('72px')};
  margin-top: ${pxToRem('24px')};
  border: solid ${pxToRem('2px')} #f0f0f0;
  border-radius: ${pxToRem('36px')};
  padding: ${pxToRem('8px')};
  background-color: ${props => props.theme.colors.white};
  min-height: ${pxToRem('72px')};

  & > div {
    height: ${pxToRem('56px')};
    border-radius: ${pxToRem('36px')};
    display: flex;
    align-items: flex-start;
    &:hover:not(:last-child),
    &:active:not(:last-child) {
      background-color: ${props => props.theme.colors.blue.five};
    }
  }
`;
